import React from 'react';
import { Typography, Grid, Box, TextField } from '@mui/material';

export default function PayslipNetpay({handleInputChange,formData}) {

  return (
   
    <Grid container spacing={2} style={{marginBottom: "30px"}}>
      <Grid item xs={12} md={6} sm={6}>
        <Box className="typography-title" >
          <Typography variant="h1" className="payslip-heading-h1">
            Net Pay
          </Typography>
        </Box>
      </Grid>
     
      <Grid container spacing={3} sx={{ display:"flex",justifyContent:"center"}} >
      
        <Grid item xs={10} md={6} sm={4}>
          <TextField
            name="net_pay"
            fullWidth
            onChange={handleInputChange}
            label="Net Pay"
            type="number"
           value={formData.net_pay}
            color="secondary"
           
          />
        </Grid>
        <Grid item xs={2} md={4} sm={4}>

        </Grid>
        <Grid item xs={10} md={8} sm={4} >
          <TextField
            name="net_pay_in_words"
            fullWidth
            onChange={handleInputChange}
            label="Net Pay Amount"
           value={formData.net_pay_in_words}
            type="text"
          />
        </Grid>
        <Grid item xs={2} md={2} sm={2} sx={{my:"20px"}}>

         </Grid>
       
      </Grid>
    </Grid>
   
  );
}
